"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var utils_1 = require("@mui/material/utils");
var SvgFrequency = (0, utils_1.createSvgIcon)(react_1.default.createElement(react_1.default.Fragment, {}, react_1.default.createElement("path", { d: "M3 4.5 6 7V5.25h12V7l3-2.5L18 2v1.75H6V2L3 4.5ZM6.64 11.937c.51-1.23 2.251-1.235 2.768-.007l3.327 7.914c1.21 2.877 5.293 2.852 6.469-.038L21.158 15h-2.16l-1.647 4.053c-.504 1.238-2.254 1.249-2.772.016l-3.328-7.914c-1.204-2.866-5.268-2.856-6.46.016L3.205 15h2.165l1.27-3.063Z" })), 'SvgFrequency');
exports.default = SvgFrequency;
